import { createReducer, on } from "@ngrx/store";
import { BalanceModel } from "./balance.model";
import { resetBalance, setBalance } from "./balance.actions";

const initialState: BalanceModel = {
  balance: '0'
}

export const balanceReducer = createReducer(
  initialState,
  on(setBalance, (state, { balance }) => ({
    ...state,
    balance
  })),
  on(resetBalance, () => initialState)
);
